// @mui material components
import Link from "@mui/material/Link";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

export default function Footer() {
	return (
		<MDBox
			component="footer"
			width="100%"
			display="flex"
			justifyContent="flex-end"
			px={1.5}
			py={2}
		>
			<MDTypography variant="button" fontWeight="regular" color="text">
				&copy; {new Date().getFullYear()}{" "}
				<Link href="https://www.digihapi.com" target="_blank" rel="noreferrer">
					<MDTypography
						component="span"
						variant="button"
						fontWeight="medium"
						color="primary"
					>
						DigiHapi
					</MDTypography>
				</Link>
				{", made by humans for humans"}
			</MDTypography>
		</MDBox>
	);
}
